export default function RadioInputButton({
  emoji,
  onChange,
  name,
  subtitle,
  title,
  value,
  preselected = false,
}: {
  emoji: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  name: string
  subtitle?: string
  title: string
  value: string
  preselected?: boolean
}) {
  return (
    <label
      className="flex w-full cursor-pointer items-center gap-3 rounded-xl border-2 bg-white p-4 hover:scale-102 hover:opacity-80 hover:drop-shadow-lg"
      style={{
        borderColor: preselected
          ? 'color-mix(in srgb, var(--color-primary) 40%, transparent)'
          : '#EAEAEA',
      }}
    >
      <input
        className="hidden"
        name={name}
        onChange={onChange}
        type="radio"
        value={value}
      />

      <span className="rounded-lg bg-transparent px-2 py-1 text-xl">
        {emoji}
      </span>

      <div className="flex flex-col">
        <span className="text-custom-black font-headline font-bold">
          {title}
        </span>
        {subtitle && <span className="text-sm text-[#757575]">{subtitle}</span>}
      </div>
    </label>
  )
}
